export const REPORT_ACTIONS = {
  PROJECT_REPORT_PAGE_LOADED: 'PROJECT_REPORT_PAGE_LOADED',
  PROJECT_REPORT_PAGE_UNLOADED: 'PROJECT_REPORT_PAGE_UNLOADED',
  PROJECT_REPORT_GET_ACTIVITIES: 'PROJECT_REPORT_GET_ACTIVITIES',
  PROJECT_REPORT_END_OF_JOB: 'PROJECT_REPORT_END_OF_JOB',
  PROJECT_REPORT_END_OF_JOB_AS_EXCEL: 'PROJECT_REPORT_END_OF_JOB_AS_EXCEL',
};
